/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class ContactListVO extends JSONable {

  uuid: string | undefined = undefined;
  businessProfileUuid: string | undefined = undefined;
  ownerLeUuid: string | undefined = undefined;
  ownerCompanyName: string | undefined = undefined;
  contactForLeUuid: string | undefined = undefined;
  companyName: string | undefined = undefined;
  isContactForPartner: boolean | undefined = undefined;
  ownerByProfile: boolean | undefined = undefined;
  phoneNumber: string | undefined = undefined;
  email: string | undefined = undefined;
  contactName: string | undefined = undefined;
  contactCountry: string | undefined = undefined;
  visibilityType: string | undefined = undefined;
  contactMethod: string | undefined = undefined;
  receivesRequests: boolean | undefined = undefined;
  deletable: boolean | undefined = undefined;
}
